<template>
  <Appendix
    title="Phụ lục phí trả góp"
    :fields="fieldsTable"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
    :_showDetails="false"
  >
    <template #cellDetail="item">
      <span
        v-if="item.isDefaultFee"
        @click="showFee('Biểu phí trả góp mặc định', item.appendixCredit.creditFeeTable)"
        class="text-info cursor"
        >Xem phí mặc định</span
      >
      <span
        v-else
        @click="showFee('Biểu phí trả góp đề xuất', item.appendixCredit.creditFeeTable)"
        class="text-info cursor"
        >Xem phí đề xuất</span
      >
    </template>
    <template #file="item">
      <div v-if="item.urlPDF" class="form-detail">
        <UploadMultiple
          :lsData="[item]"
          keyUrl="urlPDF"
          :canUpload="false"
          :title="`File phụ lục ${item.code}`"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
      </div>
    </template>
  </Appendix>
</template>
<script>
  import FeeCredit from './tariff-fee-credit.vue'
  import Appendix from './Appendix.vue'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Appendix, UploadMultiple },
    data() {
      return {
        fieldsTable: [
          { key: 'code', label: 'Số phụ lục', class: 'text-left' },
          {
            key: 'time',
            label: 'Thời gian',
            class: 'text-left',
            thStyle: 'min-width: 210px',
          },
          { key: 'detail', label: 'Chi tiết', class: 'text-right' },
          { key: 'state', label: 'Trạng thái', class: 'text-center' },
          { key: 'action', label: 'Thao tác', class: 'text-center' },
        ],
      }
    },
    methods: {
      showFee(title, data) {
        this.showModalComponentMx(title, {
          name: FeeCredit,
          props: {
            data,
          },
        })
      },
    },
  }
</script>

<style scoped></style>
